import { createSlice } from "@reduxjs/toolkit";

// localStorage.setItem("theme", "light");
const uiInitialState = {
  isDark: false,
  isAdminSidebarLong: true,
  isSidebarLong: false,
  isRealTimeResponse: false,
  isSettingsShow: false,
  isAdvanceShow: false,
  isUserDetailsShow: false,
  showIntroUserPrompt: false,
  isShowTutorial: false,
  isShowCustomVoiceAddon: false,
  config: {},
  currentPlaySound: "",
  isShowSlide: false,
  isLoginRequiredModalOpen: false,
  isWelcomeModalOpen: false,
  isSubscriptionModalOpen: false,
};

const uiCreteSlice = createSlice({
  name: "uiSlice",
  initialState: uiInitialState,
  reducers: {
    toggleSideBar(state) {
      state.isSidebarLong = !state.isSidebarLong;
    },
    toggleAdminSidebar(state) {
      state.isAdminSidebarLong = !state.isAdminSidebarLong;
    },
    toggleTheme(state) {
      state.isDark = !state.isDark;
      const theme = state.isDark ? "dark" : "light";
      localStorage.setItem("theme", theme);
    },
    toggleRealTimeResponse(state) {
      state.isRealTimeResponse = !state.isRealTimeResponse;
      const realtime = state.isRealTimeResponse ? "yes" : "no";
      localStorage.setItem("realtime", realtime);
    },
    toggleSettings(state) {
      state.isSettingsShow = !state.isSettingsShow;
    },
    toggleTutorial(state) {
      state.isShowTutorial = !state.isShowTutorial;
    },
    toggleAdvanceShow(state) {
      state.isAdvanceShow = !state.isAdvanceShow;
    },
    toggleUserDetailsShow(state) {
      state.isUserDetailsShow = !state.isUserDetailsShow;
    },
    userIntroPromptHandler(state, action) {
      state.showIntroUserPrompt = action.payload.introPrompt;
    },
    toggleCustomVoiceAddon(state) {
      state.isShowCustomVoiceAddon = !state.isShowCustomVoiceAddon;
    },
    setConfig(state, action) {
      state.config = action.payload;
    },
    setCurrentPlaySound(state, action) {
      state.currentPlaySound = action.payload;
    },
    toggleSlide(state) {
      state.isShowSlide = !state.isShowSlide;
    },
    openLoginRequiredModal(state) {
      // Ensure mutual exclusivity with welcome modal
      state.isWelcomeModalOpen = false;
      state.isLoginRequiredModalOpen = true;
    },
    closeLoginRequiredModal(state) {
      state.isLoginRequiredModalOpen = false;
    },
    openWelcomeModal(state) {
      // Ensure mutual exclusivity with login-required modal
      state.isLoginRequiredModalOpen = false;
      state.isWelcomeModalOpen = true;
    },
    closeWelcomeModal(state) {
      state.isWelcomeModalOpen = false;
    },
    openSubscriptionModal(state) {
      // Ensure other modals are closed
      state.isWelcomeModalOpen = false;
      state.isLoginRequiredModalOpen = false;
      state.isSubscriptionModalOpen = true;
    },
    closeSubscriptionModal(state) {
      state.isSubscriptionModalOpen = false;
    },
  },
});

export const uiAction = uiCreteSlice.actions;

export default uiCreteSlice.reducer;
